import { Id, MultiSelectField } from "@dgs/core";
import { ReactNode } from "react";
import { DataFieldIndexResource } from "../../types/dataField";
import {
	ContactAttributeRequest,
	IContactAttributeBaseHandler,
	IContactAttributeHandler,
	IContactAttributeListHandler,
} from "../IContactAttributeHandler";

export function createMultiSelectFieldDataFieldContactAttributeBaseHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeBaseHandler {
	return {
		type: "MULTI_SELECT_FIELD_DATA_FIELD",
		id,
		getLabel: () => dataField.label,
	};
}

export function createMultiSelectFieldDataFieldContactAttributeProfileHandler(
	id: Id,
	value: Id[] | null,
	dataField: DataFieldIndexResource,
): IContactAttributeHandler<Id[], Id[] | null> {
	const baseHandler = createMultiSelectFieldDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		value,
		validate() {
			return null;
		},
		renderValue(): ReactNode {
			return dataField.options
				.filter((o) => (this.value ?? []).includes(o.id))
				.map((o) => o.value)
				.join(", ");
		},
		renderFormField(t, prefix): ReactNode {
			return (
				<MultiSelectField
					name={`${prefix ? `${prefix}.` : ""}${id}.value`}
					label={baseHandler.getLabel(t)}
					placeholder={dataField.placeholder}
					description={dataField.description}
					options={dataField.options}
					getLabel={(option) => option.value}
					getValue={(option) => option.id}
					clearable={true}
				/>
			);
		},
		toRequestValue(): ContactAttributeRequest<Id[]> {
			return { id, value: this.value ?? [] };
		},
	};
}

export function createMultiSelectFieldDataFieldContactAttributeListHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeListHandler {
	const baseHandler = createMultiSelectFieldDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		getColumnSize: () => "1fr",
	};
}
